import { pickT } from "@repo/shared";
import { T } from "./pdf-component-labels.i18n";

/**
 * Translated label for a PDF component type. Falls back to `en_GB` for an
 * unrecognized language, and to the raw `type` string for an unrecognized
 * component type (e.g. a flow-only type passed in by mistake).
 */
export function getPdfComponentLabel(type: string, lang = "en_GB"): string {
  const labels = pickT(T, lang);
  return (labels as Record<string, string>)[type] || type;
}
